
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transaction_transfer",
      function () {
        return require("private-next-pages/transaction_transfer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transaction_transfer"])
      });
    }
  